import { Descriptions } from 'antd'
import { formatShanghaiDateTime } from '@/const/date.ts'

type ContractSummary = {
  id: number
  contractNo: string
  title: string
  createdAt: Date
  confirmedAt: Date | null
}

export function RentalContractSummary({ document }: { document: ContractSummary }) {
  return (
    <Descriptions
      column={1}
      size="small"
      items={[
        { key: 'number', label: '合同编号', children: document.contractNo },
        { key: 'title', label: '合同名称', children: document.title },
        {
          key: 'date',
          label: '出具时间',
          children: formatShanghaiDateTime(document.confirmedAt ?? document.createdAt)
        }
      ]}
    />
  )
}
